import { TextHelpJournal } from '../Help/HelpEsJournal'
import CardHelp from './CardHelp'

export const HelpJournalsOptions = () => {
  return (
    <>
        {
            TextHelpJournal.map((hlp, idx) => (
                <CardHelp
                    key={idx}
                    title={hlp.title}
                    text={hlp.text}
                ></CardHelp>
            ))
        }
    </>
  )
}